import { createApp } from "vue";

import "bootstrap";
import "./styles/scss/bootstrap.scss";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import { validateEmail, validatePassword, trimString } from "./mixins";
import { globalErrorText } from "./mixins/globalErrorText";
import { authLogin, authRegister, authLogout } from "./mixins/authFunctions";

import { onAuthStateChanged } from "firebase/auth";
import auth from "./firebase/auth";

import i18n from "./i18n";

// Mixins
const mixin = {
  methods: {
    validateEmail,
    validatePassword,
    trimString,
    globalErrorText,
    authLogin,
    authRegister,
    authLogout,
  },
};

let app = null;

onAuthStateChanged(auth, async (user) => {
  store.commit("SET_APP_LOADED_STATE", false);
  if (!app) {
    app = await createApp(App)
      .use(store)
      .use(router)
      .use(i18n)
      .mixin(mixin)
      .mount("#app");
  }
  if (user) {
    store.commit("user/SET_USER", {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      emailVerified: user.emailVerified,
    });
    await store.dispatch("authInit");
  } else {
    store.commit("user/SET_USER", null);
    store.commit("user/SET_USER", {
      language: navigator.language,
    });
  }
  store.commit("SET_APP_LOADED_STATE", true);
});
